export const affiliateAllowedCountries = [
	"Australia",
	"New Zealand",
	"United States",
	"Canada",
	"United Kingdom",
	"Ireland",
	"Singapore",
	"Denmark",
	"Sweden",
	"Norway",
	"Finland",
	"Iceland",
	"Germany",
	"Netherlands",
	"Belgium",
	"Luxembourg",
	"Switzerland",
	"Austria",
	"France",
	"Japan",
	"South Korea",
	"Estonia",
	"Latvia",
	"Lithuania",
	"Czechia",
	"Slovakia",
	"Slovenia",
	"Spain",
	"Portugal",
	"Italy",
	"Malta",
	"Poland",
	"Greece",
	"Israel",
	"Taiwan",
	"Hong Kong",
];

const affiliateCountryAliases = new Map(
	[
		["AU", "Australia"],
		["Australia", "Australia"],
		["NZ", "New Zealand"],
		["New Zealand", "New Zealand"],
		["US", "United States"],
		["USA", "United States"],
		["United States", "United States"],
		["United States of America", "United States"],
		["CA", "Canada"],
		["Canada", "Canada"],
		["GB", "United Kingdom"],
		["UK", "United Kingdom"],
		["United Kingdom", "United Kingdom"],
		["IE", "Ireland"],
		["Ireland", "Ireland"],
		["SG", "Singapore"],
		["Singapore", "Singapore"],
		["DK", "Denmark"],
		["Denmark", "Denmark"],
		["SE", "Sweden"],
		["Sweden", "Sweden"],
		["NO", "Norway"],
		["Norway", "Norway"],
		["FI", "Finland"],
		["Finland", "Finland"],
		["IS", "Iceland"],
		["Iceland", "Iceland"],
		["DE", "Germany"],
		["Germany", "Germany"],
		["NL", "Netherlands"],
		["Netherlands", "Netherlands"],
		["BE", "Belgium"],
		["Belgium", "Belgium"],
		["LU", "Luxembourg"],
		["Luxembourg", "Luxembourg"],
		["CH", "Switzerland"],
		["Switzerland", "Switzerland"],
		["AT", "Austria"],
		["Austria", "Austria"],
		["FR", "France"],
		["France", "France"],
		["JP", "Japan"],
		["Japan", "Japan"],
		["KR", "South Korea"],
		["Korea", "South Korea"],
		["South Korea", "South Korea"],
		["Republic of Korea", "South Korea"],
		["EE", "Estonia"],
		["Estonia", "Estonia"],
		["LV", "Latvia"],
		["Latvia", "Latvia"],
		["LT", "Lithuania"],
		["Lithuania", "Lithuania"],
		["CZ", "Czechia"],
		["Czechia", "Czechia"],
		["Czech Republic", "Czechia"],
		["SK", "Slovakia"],
		["Slovakia", "Slovakia"],
		["SI", "Slovenia"],
		["Slovenia", "Slovenia"],
		["ES", "Spain"],
		["Spain", "Spain"],
		["PT", "Portugal"],
		["Portugal", "Portugal"],
		["IT", "Italy"],
		["Italy", "Italy"],
		["MT", "Malta"],
		["Malta", "Malta"],
		["PL", "Poland"],
		["Poland", "Poland"],
		["GR", "Greece"],
		["Greece", "Greece"],
		["IL", "Israel"],
		["Israel", "Israel"],
		["TW", "Taiwan"],
		["Taiwan", "Taiwan"],
		["HK", "Hong Kong"],
		["Hong Kong", "Hong Kong"],
		["Hong Kong SAR", "Hong Kong"],
	].map(([key, value]) => [key.toLowerCase(), value]),
);

export const normalizeAffiliateCountry = (value?: string | null) => {
	const country = String(value || "").trim();
	if (!country) return "";
	return affiliateCountryAliases.get(country.toLowerCase()) || "";
};

export const isAffiliateCountryAllowed = (value?: string | null) =>
	Boolean(normalizeAffiliateCountry(value));
